const MDF_ACTIVITIES_NAMESPACE = 'jbp-mdf-activities'

export const MDF_ACTIVITIES_TRANSLATION_KEYS = {
  title: `${MDF_ACTIVITIES_NAMESPACE}-title`,
  empty: `${MDF_ACTIVITIES_NAMESPACE}-empty`,
  views: {
    dashboard: `${MDF_ACTIVITIES_NAMESPACE}-views-dashboard`,
  },
  dashboard: {
    refresh: {
      button: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-refresh-button`,
      tooltip: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-refresh-tooltip`,
    },
    filters: {
      title: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-filters-title`,
      strategicInitiative: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-filters-strategic-initiative`,
      businessPriority: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-filters-business-priority`,
      timeframe: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-filters-timeframe`,
      currency: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-filters-currency`,
      resetFilters: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-filters-reset`,
      close: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-filters-close`,

      strategicInitiativeBubble: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-filters-strategic-initiative-bubble`,
      businessPriorityBubble: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-filters-business-priority-bubble`,
      timeframeBubble: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-filters-timeframe-bubble`,
      resetBubble: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-filters-reset-bubble`,
    },
    overview: {
      linkage: {
        title: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-linkage-title`,
        footerTitle: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-linkage-total-activities`,
        linked: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-linkage-linked`,
        unlinked: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-linkage-unlinked`,
      },
      planned: {
        title: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-planned-title`,
        footerTitle: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-planned-in-p360-title`,
      },
      requested: {
        title: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-requested-title`,
        footerTitle: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-requested-matching-title`,
      },
      paid: {
        title: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-paid-title`,
        footerTitle: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-paid-of-requested-title`,
      },
      contra: {
        title: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-contra-title`,
        tooltip: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-contra-tooltip`,
        footerTitle: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-contra-based-on-sales-title`,
      },
      activityOutcomes: {
        title: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-activity-outcomes-title`,
        footerDescription: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-activity-outcomes-ratio-description`,
        footerTitle: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-overview-activity-outcomes-footer`,
      },
    },
    breakdown: {
      title: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-breakdown-title`,
      subtitle: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-breakdown-subtitle`,
      paid: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-breakdown-paid`,
      requested: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-breakdown-requested`,
      groupFields: {
        activityType: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-breakdown-group-activity-type`,
        businessPriority: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-breakdown-group-business-priority`,
        timeframe: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-breakdown-group-timeframe`,
        category: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-breakdown-group-category`,
        businessUnit: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-breakdown-group-business-unit`,
      },
    },
    statusFunnel: {
      title: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-status-funnel-title`,
      subtitle: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-status-funnel-subtitle`,
    },
    initiativesGroups: {
      title: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-initiatives-groups-title`,
      subtitle: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-initiatives-groups-subtitle`,
      initiative: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-initiatives-groups-initiative`,
      plannedFunds: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-initiatives-groups-planned-funds`,
      requested: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-initiatives-groups-requested`,
      paid: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-initiatives-groups-paid`,
      coverage: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-initiatives-groups-coverage`,
      activitiesCount: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-initiatives-groups-activities-count`,
      unlinkedActivitiesCount: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-initiatives-groups-unlinked-activities-count`,
      noInitiative: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-initiatives-groups-no-initiative`,
      total: `${MDF_ACTIVITIES_NAMESPACE}-dashboard-initiatives-groups-total`,
    },
  },
  linkage: {
    linkPlaceholder: `${MDF_ACTIVITIES_NAMESPACE}-linkage-link-placeholder`,
    suggestedLabel: `${MDF_ACTIVITIES_NAMESPACE}-linkage-suggested-label`,
    suggestionTooltip: `${MDF_ACTIVITIES_NAMESPACE}-linkage-suggestion-tooltip`,
    noSuggestions: `${MDF_ACTIVITIES_NAMESPACE}-linkage-no-suggestions`,
    createNew: `${MDF_ACTIVITIES_NAMESPACE}-linkage-create-new`,
  },
  table: {
    activity: `${MDF_ACTIVITIES_NAMESPACE}-table-activity`,
    timeframe: `${MDF_ACTIVITIES_NAMESPACE}-table-timeframe`,
    status: `${MDF_ACTIVITIES_NAMESPACE}-table-status`,
    bu: `${MDF_ACTIVITIES_NAMESPACE}-table-bu`,
    requested: `${MDF_ACTIVITIES_NAMESPACE}-table-requested`,
    paid: `${MDF_ACTIVITIES_NAMESPACE}-table-paid`,
    linkedInitiative: `${MDF_ACTIVITIES_NAMESPACE}-table-linked-initiative`,
    outcome: `${MDF_ACTIVITIES_NAMESPACE}-table-outcome`,
    provideOutcome: `${MDF_ACTIVITIES_NAMESPACE}-table-provide-outcome`,
    outcomeProvided: `${MDF_ACTIVITIES_NAMESPACE}-table-outcome-provided`,
  },
  outcomes: {
    outcomeLabel: `${MDF_ACTIVITIES_NAMESPACE}-outcome-label`,
    dialogPlaceholder: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-dialog-placeholder`,
    onlyMissing: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-only-missing`,
    otherInfo: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-other-info`,
    addItem: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-add-item`,
    removeItem: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-remove-item`,
    itemName: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-item-name`,
    itemValueType: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-item-value-type`,
    itemValue: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-item-value`,
    itemNamePlaceholder: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-item-name-placeholder`,
    itemValuePlaceholder: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-item-value-placeholder`,
    valueTypes: {
      financial: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-value-type-financial`,
      number: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-value-type-number`,
      percentage: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-value-type-percentage`,
      freeText: `${MDF_ACTIVITIES_NAMESPACE}-outcomes-value-type-free-text`,
    },
  },
  detailsModal: {
    title: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-title`,
    eyebrow: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-eyebrow`,
    save: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-save`,
    cancel: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-cancel`,
    tabs: {
      details: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-tabs-details`,
      financialsContacts: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-tabs-financials-contacts`,
    },
    currency: {
      usd: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-currency-usd`,
      local: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-currency-local`,
    },
    groups: {
      general: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-group-general`,
      initiative: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-group-initiative`,
      statusInitiative: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-group-status-initiative`,
      financials: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-group-financials`,
      dates: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-group-dates`,
      contacts: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-group-contacts`,
      outcome: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-group-outcome`,
    },
    fields: {
      partnerId: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-partner-id`,
      timeframe: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-timeframe`,
      activityId: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-activity-id`,
      activityType: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-activity-type`,
      activityName: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-activity-name`,
      activityStatus: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-activity-status`,
      statusCategory: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-status-category`,
      p360InitiativeId: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-p360-initiative-id`,
      strategicInitiatives: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-strategic-initiatives`,
      businessUnit: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-business-unit`,
      businessFocus: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-business-focus`,
      category: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-category`,
      requestedAmount: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-requested-amount`,
      hpContributionPercent: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-hp-contribution-percent`,
      claimPaid: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-claim-paid`,
      approvalDate: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-approval-date`,
      executionStartDate: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-execution-start-date`,
      executionEndDate: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-execution-end-date`,
      partnerContactEmails: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-partner-contact-emails`,
      hpContactEmails: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-hp-contact-emails`,
      keyInitiativeId: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-key-initiative-id`,
      keyInitiativeMatchPercent: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-key-initiative-match-percent`,
      keyInitiativeSuggestions: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-key-initiative-suggestions`,
      keyInitiativeLinkType: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-key-initiative-link-type`,
      outcome: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-outcome`,
      outcomeValueType: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-outcome-value-type`,
      businessPriorities: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-business-priorities`,
      businessPriority: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-business-priority`,
      linkType: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-link-type`,
      initiativeName: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-initiative-name`,
      initiativeStrategicInitiative: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-initiative-strategic-initiative`,
      initiativeDescription: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-initiative-description`,
      funnelSize: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-funnel-size`,
      leads: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-leads`,
      conversionRate: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-conversion-rate`,
      attendance: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-attendance`,
      estimatedSales: `${MDF_ACTIVITIES_NAMESPACE}-details-modal-field-estimated-sales`,
    },
  },
}
